import React from "react";
import styled from "styled-components";

const HeaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-bottom: 0.5rem;
`;

const HeaderText = styled.span`
  text-align: center;
  font-size: 1.5rem;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.primary};
`;

export const SubText = styled.span`
  display: flex;
  align-items: center;
  text-align: center;
  font-size: 0.8rem;
`;

export default function Header({ text, subtext1, subtext2 }) {
  return (
    <HeaderWrapper>
      <HeaderText>{text}</HeaderText>
      <SubText>
        <i>{subtext1}</i>
      </SubText>
      <SubText>
        <i>{subtext2}</i>
      </SubText>
    </HeaderWrapper>
  );
}
